// extracted by mini-css-extract-plugin
export var body = "_28-8";
export var button = "_28-0";
export var closeButton = "_28-5";
export var content = "_28-3";
export var empty = "_28-f";
export var grid = "_28-c";
export var header = "_28-4";
export var icon = "_28-1";
export var option = "_28-d";
export var optionSelected = "_28-e";
export var overlay = "_28-2";
export var searchIcon = "_28-a";
export var searchInput = "_28-b";
export var searchWrapper = "_28-9";
export var title = "_28-6";
export var visuallyHidden = "_28-7";